import {
  SaveUserProfileMutation,
  SaveUserProfileMutationVariables,
  useSaveUserProfileMutation,
} from '@coverright/data-access/enrollment';
import { MutationHookOptions } from '@apollo/client';
import { enrollmentApolloClient } from '@coverright/data-access/apollo-clients';

export function useSaveUserProfile(
  options?: MutationHookOptions<
    SaveUserProfileMutation,
    SaveUserProfileMutationVariables
  >
) {
  return useSaveUserProfileMutation({
    client: enrollmentApolloClient,
    awaitRefetchQueries: true,
    refetchQueries: ['userProfile'],
    ...options,
  });
}
